import { render } from "./MyAccount.vue?vue&type=template&id=8baa3c7c&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=ts"
export * from "./MyAccount.vue?vue&type=script&lang=ts"

import "./MyAccount.vue?vue&type=style&index=0&id=8baa3c7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8baa3c7c"

export default script